module.exports = __webpack_public_path__ + "static/media/frowning_face.11f34554.png";